import { usersRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { UserKey } from './types';

export const useGetCurrentUser = () => {
  return useQuery({
    queryKey: [...UserKey.CURRENT_USER],
    queryFn: () => {
      return usersRepo.getCurrentUser();
    },
  });
};
